import React from 'react'
import { useTranslation } from 'react-i18next'

import { BaseModalType } from '@context/ModalsContext'

import { Modal } from '@ui/components/Modal'
import { RadioProps } from '@ui/components/Radio'

import { SelectOption } from '@utils/date.utils'

export interface OptionSplitter {
  value: string
  index: number
}

interface Props {
  title?: string
  options: SelectOption[]
  initialValue?: number
  splitter?: OptionSplitter[]
  onChangeOption(optionId: number): void
}

export const PeriodModal: BaseModalType<Props> = (props) => {
  const { t } = useTranslation()
  const { options, initialValue, splitter, onChangeOption, close } = props
  const { title = t('Statements.Select') } = props

  const radioOptions: RadioProps[] = options.map((opt) => ({
    label: opt.label,
    value: String(opt.id),
    disabled: opt.disabled,
  }))

  const handleConfirm = (value: string) => {
    const id = parseInt(value, 10)
    if (!Number.isNaN(id)) {
      onChangeOption(id)
    }
    close()
  }

  const sections: { header?: string; options: RadioProps[] }[] = []
  if (splitter && splitter.length > 0) {
    const sorted = [...splitter].sort((a, b) => a.index - b.index)
    let start = 0
    sorted.forEach((s, i) => {
      const slice = radioOptions.slice(start, s.index)
      if (slice.length) {
        sections.push({ header: i === 0 ? sorted[0].value : sorted[i - 1].value, options: slice })
      }
      sections.push({ header: s.value, options: [] })
      start = s.index
    })
    const tail = radioOptions.slice(start)
    if (tail.length) {
      sections.push({ options: tail })
    }
  } else {
    sections.push({ options: radioOptions })
  }

  const normalized: { header?: string; options: RadioProps[] }[] = []
  sections.forEach((sec) => {
    if (sec.options.length === 0) {
      normalized.push(sec)
    } else if (normalized.length && !normalized[normalized.length - 1].options.length) {
      normalized[normalized.length - 1] = {
        header: normalized[normalized.length - 1].header,
        options: sec.options,
      }
    } else {
      normalized.push(sec)
    }
  })

  return (
    <Modal>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Body>
        {normalized.map((section, idx) => (
          <React.Fragment key={`section-${idx}`}>
            {section.header && <Modal.Body.Title>{section.header}</Modal.Body.Title>}
            {section.options.length > 0 && (
              <Modal.Body.Input.Radio
                value={initialValue?.toString() || ''}
                name='period-modal'
                options={section.options}
                onChange={handleConfirm}
              />
            )}
          </React.Fragment>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Modal.Footer.Secondary onClick={close}>{t('Cancel')}</Modal.Footer.Secondary>
      </Modal.Footer>
    </Modal>
  )
}
